import React,{useEffect,useState,lazy,Suspense} from 'react'
import {Routes,Route,useNavigate} from 'react-router-dom'
import './App.css';
import BookingsComponent from './components/Bookings/BookingsComponent';
import Footer from './components/Footer/Footer';
import HomeComponent from './components/Home/HomeComponent';
import LoginComponent from './components/Login/LoginComponent';
import Navbar from './components/Navbar/Navbar';
import PricingComponent from './components/Pricing/PricingComponent';
import ServicesComponent from './components/Services/ServicesComponent';
import UserComponent from './components/User/UserComponent';
import PaymentsComponent from './components/Payments/PaymentsComponent';
import RegisterComponent from './components/Register/RegisterComponent';
import AboutComponent from './components/About/AboutComponent';
import TrainersComponent from './components/Trainers/TrainersComponent';
import CustomAdminComponent from './components/Admin/CustomAdminComponent';
import AdminComponent from './components/Admin/AdminComponent';
import CustomTableComponent from './components/Bookings/CustomTableComponent';
import GalleryComponent from './components/Gallery/GalleryComponent';
import ManageGallery from './components/Admin/Gallery/ManageGallery';
import PermBookingComponent from './components/Bookings/PermBookingComponent';
import ManagePermBookingComponent from './components/Admin/ManagePermBookingComponent';
import AddTrainersComponent from './components/Admin/AddTrainersComponent';
import ManageTermDatesComponent from './components/Admin/TermDates/ManageTermDatesComponent';
import ServicesComponent1 from './components/Admin/Services/ServicesComponent';
import SquadComponent from './components/Admin/Squad/SquadComponent';
import SquadInfoComponent from './components/Admin/SquadInfo/SquadInfoComponent';
import DisclaimerComponent from './components/Admin/Disclaimer/disclaimerComponent';
import ManageHolidays from './components/Admin/Holiday/ManageHolidays';
import ContactUsComponent from './components/contactus/ContactUsComponent';
import FailedBookings from './components/FailedBookings/FailedBookings';
import DeletedBookingsComponent from './components/Admin/DeletedBookingsComponent';
import { invokeHolidays } from './components/ServiceCalls/ApiCalls';

function App() {

  const navigate = useNavigate()
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)

  useEffect(() =>{
    // Check if user is logged in
    const checkLoginStatus = () => {
      const user = localStorage.getItem('user')
      setIsUserLoggedIn(!!user)
    }

    // Initial check
    checkLoginStatus()

    // Listen for storage changes (when user logs in/out)
    const handleStorageChange = () => {
      checkLoginStatus()
    }

    window.addEventListener('storage', handleStorageChange)
    
    // Also listen for custom events when login state changes
    window.addEventListener('loginStateChange', handleStorageChange)

    if(localStorage.getItem('user')){
      localStorage.clear()
      navigate('/')
      setIsUserLoggedIn(false) // Update state after clearing
    }
    
    async function fetchHolidays(){
      const holidaysList = await invokeHolidays();
      localStorage.setItem('holidays',JSON.stringify(holidaysList));
    }
     fetchHolidays()

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('loginStateChange', handleStorageChange)
    }

  },[])

  return (
    <>
         <Navbar/>
         <div className='main_section'>
            <Routes>
                <Route path='/' element={<HomeComponent/>} />
                <Route path='*' element={<HomeComponent/>} />
                <Route path='/about' element={<AboutComponent/>} />
                <Route path='/login' element={<LoginComponent/>} />
                <Route path='/services' element={<ServicesComponent/>}/>
                <Route path='/price' element={<PricingComponent/>} />
                <Route path='/user' element={<UserComponent/>} />
                <Route path='/bookings' element={<CustomTableComponent/>} />
                <Route path='/bookingstest' element={<BookingsComponent/>} />
                <Route path='/payments' element={<PaymentsComponent/>} />
                <Route path='/register' element={<RegisterComponent/>} />
                <Route path='/coach' element={<TrainersComponent/>} />
                <Route path='/gallery' element={<GalleryComponent/>} />
                <Route path='/addgallery' element={<ManageGallery/>} />
                <Route path='/admin' element={<CustomAdminComponent/>} />
                <Route path='/adminbook' element={<AdminComponent/>} />
                <Route path='/permbook' element={<PermBookingComponent/>} />
                <Route path='/mpermbook' element={<ManagePermBookingComponent/>} />
                <Route path='/addtrainer' element={<AddTrainersComponent/>} />
                <Route path='/addterm' element={<ManageTermDatesComponent/>} />
                <Route path='/addservice' element={<ServicesComponent1/>} />
                <Route path='/addsquad' element={<SquadComponent/>} />
                <Route path='/addsquadinfo' element={<SquadInfoComponent/>} />
                <Route path='/add-disclaimer' element={<DisclaimerComponent/>} />
                <Route path='/holidays' element={<ManageHolidays/>} />
                <Route path='/contact' element={<ContactUsComponent/>} />
                <Route path='/failed-bookings' element={<FailedBookings />} />
                <Route path='/deleted-bookings' element={<DeletedBookingsComponent />} />
            </Routes>
         </div>
         {!isUserLoggedIn && <Footer/>}
    </>
  );
}

export default App;
